import styled from 'styled-components';
import { fadeIn } from 'components/Animations';

export const ToolTipMessage = styled.div`
  flex: 1;
  top: ${props => props.inline ? '25%' : props.position.y - 24 + 'px'};
  left: ${props => props.inline ? 'calc(100% + 8px)' : props.position.x + 24 + 'px'};
  width: 200px;
  padding: 12px;
  display: flex;
  z-index: 999999;
  padding-left: 24px;
  padding-right: 24px;
  position: absolute;
  border-radius: 4px;
  justify-content: center;
  background-color: rgb(45,68,83);
  transition: all 0.2s ease-in-out;
  display: ${props => props.isShowing ? 'flex' : 'none'};
  ${fadeIn}
`;

export const ToolTipContainer = styled.div`
  position: relative;
`;

export const ArrowLeft = styled.div`
  width: 0;
  height: 0;
  left: -12px;
  position: absolute;
  top: calc(50% - 12px);
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 12px solid rgb(45,68,83);
`;
